class CasekooCartRecommendation extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return;

    this.dataset.bound = 'true';
    this.button = this.querySelector('[data-recommendation-add]');
    this.error = this.querySelector('[data-recommendation-error]');
    this.variantId = Number(this.dataset.variantId);
    this.cartAddUrl = this.dataset.cartAddUrl;
    this.defaultButtonText = this.button?.textContent.trim() || '';
    this.loadingText = this.dataset.loadingText || this.defaultButtonText;
    this.variantButtons = this.querySelectorAll('[data-recommendation-variant]');

    this.variantButtons.forEach((variantButton) => {
      variantButton.addEventListener('click', () => this.selectVariant(variantButton));
    });

    if (!this.button || !this.variantId || !this.cartAddUrl) return;

    this.button.addEventListener('click', () => this.addToCart());
  }

  selectVariant(variantButton) {
    if (variantButton.disabled) return;

    this.variantId = Number(variantButton.dataset.variantId);
    this.dataset.variantId = String(this.variantId);
    this.variantButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button === variantButton));
    });

    const price = this.querySelector('[data-recommendation-price]');
    const comparePrice = this.querySelector('[data-recommendation-compare-price]');
    const image = this.querySelector('.ck-cart-recommendation__image');
    const links = this.querySelectorAll('.ck-cart-recommendation__media, .ck-cart-recommendation__title');

    if (price) price.textContent = variantButton.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = variantButton.dataset.comparePrice || '';
      comparePrice.hidden = !variantButton.dataset.comparePrice;
    }
    if (image && variantButton.dataset.image) {
      image.src = variantButton.dataset.image;
      image.removeAttribute('srcset');
    }
    links.forEach((link) => {
      link.href = variantButton.dataset.variantUrl;
    });
    if (this.error) this.error.textContent = '';
  }

  async addToCart() {
    if (this.button.disabled) return;

    this.button.disabled = true;
    this.button.textContent = this.loadingText;
    this.error.textContent = '';

    const formData = new FormData();
    formData.append('id', String(this.variantId));
    formData.append('quantity', '1');
    formData.append('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(this.cartAddUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || window.theme?.strings?.cartError);
      }

      document.body.dispatchEvent(
        new CustomEvent('shapes:cart:afteradditem', {
          bubbles: true,
          detail: {
            response: data,
            sourceId: this.dataset.productRoot,
          },
        })
      );
    } catch (error) {
      this.error.textContent =
        error.message || window.theme?.strings?.cartError || 'Unable to add this product.';
      this.button.disabled = false;
      this.button.textContent = this.defaultButtonText;
    }
  }
}

if (!customElements.get('casekoo-cart-recommendation')) {
  customElements.define('casekoo-cart-recommendation', CasekooCartRecommendation);
}
